module.exports = __webpack_public_path__ + "static/media/shield-happy.56e07c11.webp";